export const navLinks = [
  { label: "About", path: "/about" },
  { label: "Work", path: "/work" },
  { label: "Contact", path: "/contact" },
];

export const instagramUrl = "https://www.instagram.com/definitionfilms";

export const galleryItems = [
  {
    id: 1,
    title: "Pisoni Vineyards",
    category: "Brand Film",
    location: "Santa Lucia Highlands, CA",
    image:
      "https://images.squarespace-cdn.com/content/v1/6280a7a56bb4dc131be0c339/231fb43d-c25c-45e4-afa9-106bf9969fa9/gary-pisoni.jpg",
    alt: "Vintner with curly gray hair standing among yellow-green vines with arms outstretched under a clear sky.",
    award: "Gold Winner",
  },
  {
    id: 2,
    title: "Santa Rosa Junior College",
    category: "Non-Profit",
    location: "Santa Rosa, CA",
    image:
      "https://images.squarespace-cdn.com/content/v1/6280a7a56bb4dc131be0c339/9f84d1e7-9632-4492-893b-70baacb3f673/srjc-1.jpg",
    alt: "Students walking outside a modern college campus building with trees and landscaped areas.",
    award: "",
  },
  {
    id: 3,
    title: "Redwood Empire Food Bank",
    category: "Non-Profit",
    location: "Sonoma County, CA",
    image:
      "https://images.squarespace-cdn.com/content/v1/6280a7a56bb4dc131be0c339/41e61e40-bbe9-4bbf-bb6c-36b98a475c66/refb-muse.jpg",
    alt: "A young girl in a yellow jacket receiving an apple at a farmers market with shoppers behind her.",
    award: "Gold Winner",
  },
  {
    id: 4,
    title: "Ridge Vineyards",
    category: "Brand Film",
    location: "Monte Bello, CA",
    image:
      "https://images.squarespace-cdn.com/content/v1/6280a7a56bb4dc131be0c339/3c1ec368-a724-4c46-a00c-83140597f693/DF_Ridge_Monte_Bello-203.jpg",
    alt: "An older man tasting red wine in a winery cellar while wearing a Ridge Winery vest.",
    award: "",
  },
  {
    id: 5,
    title: "Russian River Brewing Co.",
    category: "Commercial",
    location: "Windsor, CA",
    image:
      "https://images.squarespace-cdn.com/content/v1/6280a7a56bb4dc131be0c339/1717630683670-D6V3HMTXF5EEXT55PILV/rrbc.jpg",
    alt: "Two people pouring beer from taps at a tasting station with a wooden wall background.",
    award: "Gold Winner",
  },
  {
    id: 6,
    title: "Carruthers Violin",
    category: "Brand Film",
    location: "Sebastopol, CA",
    image:
      "https://images.squarespace-cdn.com/content/v1/6280a7a56bb4dc131be0c339/be52d6d1-061d-48c5-92d8-13dd2c2f3818/andy-muse-webby.jpg",
    alt: "An elderly craftsman with glasses carving a wooden violin in a workshop.",
    award: "Webby Nominee",
  },
];

export const workFilters = [
  "All",
  "Brand Film",
  "Commercial",
  "Non-Profit",
];

export const services = [
  {
    title: "Brand Films",
    description: "Give people a reason to choose you over everyone else.",
    linkLabel: "View Brand Work",
    linkHref: "/work",
  },
  {
    title: "Non-Profit Fundraising Films",
    description:
      "The right story can transform a donor's hesitation into a conviction. We find that story.",
    linkLabel: "View Fundraising Films",
    linkHref: "/work",
  },
  {
    title: "Commercials",
    description:
      "Turn viewers into customers. We build commercials that earn their keep.",
    linkLabel: "View Commercials",
    linkHref: "/work",
  },
  {
    title: "Content",
    description:
      "Stay visible all year. We build a content library that works for you long after we're done.",
    linkLabel: "View Social Content",
    linkHref: "/work",
  },
];

export const brandLogosImage =
  "https://images.squarespace-cdn.com/content/v1/6280a7a56bb4dc131be0c339/a3275692-4dea-4764-817d-053f23398c77/df.jpg";

export const testimonial = {
  name: "Ryan Johnson",
  role: "Director of Marketing, Ridge Vineyards",
  quote:
    "Definition Films is far more than a video production agency to us. They are valued creative partners and an integral part of our digital marketing team.",
  avatar:
    "https://images.squarespace-cdn.com/content/v1/6280a7a56bb4dc131be0c339/798ca3d5-9b4a-4ae0-ac11-72eea411c62d/1699293949051.jpeg",
  avatarAlt: "Smiling man in a cap and quarter-zip sweater.",
  linkHref: "https://clutch.co/go-to-review/70a03f17-e935-4f33-bcc3-4c8560a9c232/481142",
};

export const logoImage =
  "https://images.squarespace-cdn.com/content/v1/6280a7a56bb4dc131be0c339/204a0748-d2d9-4ced-8567-b5850d95a861/DF_Black.png?format=1500w";

export const heroVideoUrl =
  "https://player.vimeo.com/video/712253612?background=1&autoplay=1&loop=1&muted=1&byline=0&title=0";